export function cleanNoise(this: string): string {
  return "";
}

export class KeywordManager {
  private _Keywords: string[] = [];

  GetCommaList(): string {
    return "\"" + this._Keywords.join("\",\"") + "\"";
  }
  cleanNoise(this: string): string {
    return "";
  }
  get Keywords(): string[] {
    return this._Keywords;
  }
  BreakdownList(keyList: string): void {
    this._Keywords = [];
    keyList = keyList.replace("“", "\"").replace("”", "\"");
    //console.log(keyList)
    const csvRegex = new RegExp("\"[^\"\\r\\n,]*\"", "g");
    const t = keyList.match(csvRegex);
    // console.log(t);
    if (t) {
      const tempKeywords = t
        .map(
        match => this.CleanNoise(match.replace("\"", ""))
        )
        .filter(s => s.length > 0);

      this._Keywords = Array.from(new Set(tempKeywords));
      // console.log(this._Keywords);
    }
  }
  CleanNoise(originalKeyword: string): string {
    //remove any lower case junk words. Note this is to match Silverlight behavior. The backend ignores case and removes these junk words if the are the whole keyword, but allows them as part of a keyword that is a phrase
    const ignoreWords = new RegExp("\\b(a|all|am|an|and|any|are|as|at|be|but|can|did|do|does|for|from|had|has|have|here|how|i|if|in|is|it|no|not|of|on|or|so|that|the|then|there|this|to|too|up|use|what|when|where|who|why|you|good|company)\\b"
      , "g");
    const regEx = new RegExp('[^ 0-9A-Za-z]', "ig")
    var cleanKeyword = originalKeyword.replace(regEx, '');

    const rtn = cleanKeyword.replace(ignoreWords, '').trim();

    return rtn;
  }

}

